import script from "./TagPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./TagPicker.vue?vue&type=script&setup=true&lang=js"

import "./TagPicker.vue?vue&type=style&index=0&id=840e3540&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-840e3540"]])

export default __exports__